import { BreadcrumbsItem } from '@frontend/components/interface';
import { Breadcrumbs, Button } from '@frontend/components/ui';
import { useProjectPermission } from '@frontend/editor/data-access';
import { AppBar, Box, Toolbar as MuiToolbar } from '@mui/material';
import { styled } from '@mui/system';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ToolbarProps {
  status: number;
  breadcrumbItems: BreadcrumbsItem[];
  breadcrumbNow: BreadcrumbsItem;
  disabled?: boolean;
  onPublish: () => void;
  onSave: () => void;
}

const AppBarStyled = styled(AppBar)(({ theme }) => ({
  height: '60px',
  background: theme.palette['background']['primary']['5'],
  boxShadow: 'none',
  display: 'flex',
}));

const BreadcrumbsWrapper = styled(Box)`
  flex-grow: 1;
`;

export const Toolbar: FC<ToolbarProps> = ({
  status,
  breadcrumbItems,
  breadcrumbNow,
  disabled = false,
  onSave,
  onPublish,
}: ToolbarProps) => {
  const [t] = useTranslation();
  const { isViewer } = useProjectPermission();

  const now = {
    ...breadcrumbNow,
    label: `${breadcrumbNow.label} ${
      isViewer ? t('common.breadcrumbs.viewerModel') : ''
    }`,
  };

  return (
    <AppBarStyled position="static" color="inherit">
      <MuiToolbar>
        <BreadcrumbsWrapper>
          <Breadcrumbs history={breadcrumbItems} now={now} />
        </BreadcrumbsWrapper>
        <Button
          onClick={onSave}
          color="primary"
          sx={{ textTransform: 'uppercase' }}
        >
          <Trans i18nKey="common.save" />
        </Button>
        <Button
          onClick={onPublish}
          variant="contained"
          color="primary"
          sx={{ textTransform: 'uppercase' }}
          disabled={status === 2 || disabled}
        >
          {status <= 1 ? (
            <Trans i18nKey="common.publish" />
          ) : (
            <Trans i18nKey="common.update" />
          )}
        </Button>
      </MuiToolbar>
    </AppBarStyled>
  );
};

export default Toolbar;
